module.exports = __webpack_public_path__ + "media/4.5be03823.wav";